import { combineReducers } from 'redux';
import { gameUIReducer } from './gameUIReducer';

export const uiRootReducer = combineReducers({
  gameUI: gameUIReducer
});

export type UIRootState = ReturnType<typeof uiRootReducer>; 